<template>
    <div ref="lockMode" class="lock-mode-button">
        <span class="drawing-type">{{drawType}}</span> drawing
        <button
        role="button"
        title="lock button"
        class="lock-mode-button--button"
        @click="toggleLock()"
        >
            <md-icon v-if="!locked">lock_open</md-icon>
            <md-icon v-else>lock</md-icon>
        </button>

        <button
        role="button"
        title="exit button"
        class="lock-mode-button--button"
        @click="hideLockControls"
        >
            <md-icon>close</md-icon>
        </button>

    </div>
</template>

<script>
export default {
    name: "GoogleMapLockMode",
    props: {
        google: {
            type: Object,
            required: true
        },
        map: {
            type: Object,
            required: true
        },
        drawType: {
            type: String,
            required: true
        }
    },
    data: () => ({
        locked: false,
        showLockControls: true
    }),
    created () {

    },
    mounted() {
        // this positions the button into the LHS map controls
        const lockMode = this.$refs.lockMode;
        this.map.controls[this.google.maps.ControlPosition.TOP_CENTER].push(lockMode);
    },
    methods: {
        hideLockControls() {
            this.showLockControls = false
            this.$emit("hide-lock-controls")
        },
        toggleLock() {
            this.locked = !this.locked
            this.$emit("drawing-lock-status", this.locked)
        }
    },
}
</script>